import r2wc from '@r2wc/react-to-web-component';
import { WebComponentWrapper } from './WebComponentWrapper.tsx';
import { DonorPage } from '../components/Pages/DonorPage.tsx';
import type { LandingPageLink } from './LandingPageWebComponent';

type Props = {
	year?: number;
	intro_text?: string;
	last_updated?: string;
	methodology?: string;
	section_1_chart_heading?: string;
	section_2_chart_heading?: string;
	section_3_chart_heading?: string;
	section_4_chart_heading?: string;
	section_5_chart_heading?: string;
	menu_links?: LandingPageLink[];
	donor_gap_national_filter?: string;
	ussenate_data_donor_money?: string;
	ushouse_data_donor_money?: string;
	ussenate_data_donor_cont?: string;
	ushouse_data_donor_cont?: string;
};

const WrappedPage = ({
	year,
	intro_text,
	last_updated,
	methodology,
	section_1_chart_heading,
	section_2_chart_heading,
	section_3_chart_heading,
	section_4_chart_heading,
	section_5_chart_heading,
	menu_links,
	donor_gap_national_filter,
	ussenate_data_donor_money,
	ushouse_data_donor_money,
	ussenate_data_donor_cont,
	ushouse_data_donor_cont
}: Props) => {
	// Build section headings object
	const sectionHeadings: Record<string, string> = {};
	if (section_1_chart_heading) sectionHeadings.section_1 = section_1_chart_heading;
	if (section_2_chart_heading) sectionHeadings.section_2 = section_2_chart_heading;
	if (section_3_chart_heading) sectionHeadings.section_3 = section_3_chart_heading;
	if (section_4_chart_heading) sectionHeadings.section_4 = section_4_chart_heading;
	if (section_5_chart_heading) sectionHeadings.section_5 = section_5_chart_heading;

	return (
		<WebComponentWrapper
			year={year}
			dataFormProvider
			menuLinks={menu_links}
			pageContent={{
				introText: intro_text,
				methodology,
				lastUpdated: last_updated,
				sectionHeadings
			}}
			customFilterUrl={donor_gap_national_filter}
			ussenateDataDonorMoney={ussenate_data_donor_money}
			ushouseDataDonorMoney={ushouse_data_donor_money}
			ussenateDataDonorCont={ussenate_data_donor_cont}
			ushouseDataDonorCont={ushouse_data_donor_cont}
		>
			<DonorPage />
		</WebComponentWrapper>
	);
};

export const WebDonorPagePage = r2wc(WrappedPage, {
	props: {
		year: 'number',
		intro_text: 'string',
		last_updated: 'string',
		methodology: 'string',
		section_1_chart_heading: 'string',
		section_2_chart_heading: 'string',
		section_3_chart_heading: 'string',
		section_4_chart_heading: 'string',
		section_5_chart_heading: 'string',
		menu_links: 'json',
		donor_gap_national_filter: 'string',
		ussenate_data_donor_money: 'string',
		ushouse_data_donor_money: 'string',
		ussenate_data_donor_cont: 'string',
		ushouse_data_donor_cont: 'string'
	}
});
